<div class="pop" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <header>
    <ng-container>
      <h3 langkey="tags_title_filter_preferences"></h3>
      <div class="icon" inlineSVG="sot/sot-icon.svg#sot-tagFilter-ani" [setSVGAttributes]="{class: 'box-icon'}"></div>
    </ng-container>
    <p langkey="tags_select_preferences_text"></p>
  </header>
  <div class="product-tags">
    <ng-container *ngIf="productTags.length>0">
      <sot-scroller-vertical>
        <div class="product-tags--list">
          <div class="tag" *ngFor="let tag of productTags;let i = index" id="productTag{{tag.id}}"
            [ngClass]="{'tag-selected--highlight': isHighlighted(tag.id)}" (click)="selectTag(tag.id)">
            <div class="tag-svg" [innerHTML]="tag.svg_html"></div>
            <h3 class="tag-name"> {{tag.name}}</h3>
            <div class="tag-selection">
              <a class="btn insert" [ngClass]="{'tag-selected--highlight': isHighlighted(tag.id)}">
                <div inlineSVG="sot/sot-icon.svg#sot-done" flex [setSVGAttributes]="{class: 'icon'}"></div>
              </a>
            </div>
          </div>
        </div>
      </sot-scroller-vertical>
    </ng-container>
  </div>
  <footer class="buttons">
    <button mat-button class="btn goback insert" [class.disabled]="resetBtnDisabled()"
      (click)="resetSelectedTagFilter()">
      <div inlineSVG="sot/sot-icon.svg#sot-close" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
      <span langkey="tags_button_reset_filter"></span>
    </button>
    <button mat-button (click)="setSelectedTagFilter()" class="btn goforward">
      <span langkey="tags_apply_filter"></span>
      <div inlineSVG="sot/sot-icon.svg#sot-forward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
    </button>
  </footer>
</div>